export default {
    addProductToCart: { method: 'post', url: 'sale/open/' },
  }
  